angular = require( 'angular' )

app = angular.module( 'workflow.app' )
app.directive( 'stepTemplateSourceList', require( './List' ) )
